import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import MessageAPI from '../../../../axios/message';
import { PanelConfirm } from '../panel-ui';
import { PanelIcon } from '../../user-panel';

export const BlockedUsers = () => {
    const { t } = useTranslation(["message"]);
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [userToUnblock, setUserToUnblock] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        MessageAPI.getBlockedUsers().then(res => {
            setBlockedUsers(res.data);
            setLoaded(true);
        }).catch(e => {
            console.log(e);
        });
    }, []);

    const unblockUser = () => {
        const userId = userToUnblock;
        setError(false);
        MessageAPI.unblockUser(userId).then(() => {
            setBlockedUsers(prevUsers => prevUsers.filter(user => user.blocked.id !== userId));
        }).catch(() => {
            setError(true);
        });
    };

    if (!loaded) return null;

    if (blockedUsers.length === 0) {
        return (
            <div className='hs-panel-card hs-panel-empty'>
                <span className='hs-panel-empty-icon'><PanelIcon name='user' size={24} /></span>
                <h2>{t("no_blocked")}</h2>
            </div>
        );
    }

    return (
        <>
            {error && <span className='hs-panel-status err'>{t("unblock_error")}</span>}
            <div className='hs-panel-card hs-panel-rows'>
                {blockedUsers.map(({ blocked }) => (
                    <div className='hs-panel-row' key={blocked.id}>
                        <span className='hs-panel-message-person'>
                            <span className='hs-panel-message-avatar'>{`${blocked.first_name?.[0] || ''}${blocked.last_name?.[0] || ''}`.toUpperCase()}</span>
                            <span className='hs-panel-row-title'>{blocked.first_name} {blocked.last_name}</span>
                        </span>
                        <button className='hs-panel-outline' onClick={() => setUserToUnblock(blocked.id)}>{t('unblock')}</button>
                    </div>
                ))}
            </div>
            {userToUnblock !== null && <PanelConfirm title={t("block_confirm_title")} message={t("unblock_confirm_message")} confirmLabel={t('unblock')}
                onClose={() => setUserToUnblock(null)} onConfirm={unblockUser} />}
        </>
    );
};
